import { useNavigate, useParams } from 'react-router-dom';
import Typography from '@mui/joy/Typography';
import AuthLayout from '../../components/AuthLayout/AuthLayout';
import Athenalogo from '../../assets/images/Athena_logo_final.png';
import { useActivateAccountMutation } from '../../services/api.user';
import ChangePasswordForm from '../../components/ChangePasswordForm/ChangePasswordForm';
import { isFetchBaseQueryError } from '../../utils/isFetchBaseQueryError';

export default function ActivateAccount() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [activateAccount, { isLoading, error }] = useActivateAccountMutation();

  async function onSubmit(password: string) {
    if (!token) {
      return;
    }
    const result = await activateAccount({ token, password });

    if ('data' in result) {
      navigate('/login');
    }
  }

  const errorMessage = isFetchBaseQueryError(error) ? error.data?.message : undefined;
  return (
    <AuthLayout>
      <img
        src={Athenalogo}
        alt="logo"
        style={{
          width: '40%',
          padding: '8% 0 0 0'
        }}
      />
      <Typography level="body-lg" marginTop={2}>
        Activate an account
      </Typography>
      <ChangePasswordForm onSubmit={onSubmit} isLoading={isLoading} />
      <Typography level="body-md" color="danger">
        {errorMessage}
      </Typography>
    </AuthLayout>
  );
}
